module.exports = __webpack_public_path__ + "img/SpinLogo.97724836.svg";